import React, { JSX } from "react";
import { useSelector } from "react-redux";

export type FooterProps = {
  content?: JSX.Element[] | JSX.Element | string;
  children?: JSX.Element[] | JSX.Element | string;
  companyPrimaryColor?: string;
};

function Footer ({ content, children }: FooterProps) {
  const companyPrimaryColor = useSelector((state: any) => state.user.companyPrimaryColor);
  const primaryColor = companyPrimaryColor || "#304EA1";

  return (
    /* `data-fab-obstacle`: the AI assistant FAB is `fixed bottom-6 end-6` and was resting on top of
       this band (measured at 1440). The FAB's own dodge only looked for clickables, so the marker
       tells it this strip counts too and it lifts clear. See components/ai-chat/AIAssistant.tsx. */
    <div
      data-fab-obstacle
      className="flex-shrink-0 bg-card border-t"
      style={{ borderTopColor: `${primaryColor}20` }}
    >
      <div className="border-t border-border" />
      <div className="flex justify-around items-center text-[8px] py-0.5 text-muted-foreground bg-card border-t border-border font-['Segoe_UI',sans-serif]">
        {content || children}
      </div>
    </div>
  );
}

export default Footer;
